export const cellSize = 6.5
export const radius = 2
export const mapScale = 1.3

export const ambientSpeed = 0.04
export const ambientScale = 3.7
export const ambientCutoff = 1.0

export const scaleRadius = 100
export const scaleStrength = 0.3

export const getMapPath = (location) => {
  return `/images/locations/square/${location}@sm.webp`
}
